var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.4,
    height: 22.5,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m1.3961,1.25075l31.7776,0l-1.9861,12l0,8l-27.8054,0l0,-8l-1.9861,-12z",
    fill: "#DA9038",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.2015,1.25075l3.9722,0l-1.9861,12l0,8l-3.9722,0l0,-8l1.9861,-12z",
    fill: "#C47519",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.3685,1.25075l-3.9722,0l1.9861,12l0,8l3.9722,0l0,-8l-1.9861,-12z",
    fill: "#F0B168",
    id: "svg_3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopper);
export default __webpack_public_path__ + "static/media/Stopper.e3d3e0e1cd289e6f40e2c11a4f5df46a.svg";
export { ForwardRef as ReactComponent };